import { useTranslation } from "react-i18next";
import FAQAccordionItem from "./components/FAQAccordionItem";
import FAQDataAr from "./components/FAQDataAr";
import FAQDataEn from "./components/FAQDataEn";

export function FAQ() {
    const { t, i18n } = useTranslation();
    return (
        <div className="container my-3 rounded position-relative p-3 pb-5">
            <h1 className="mb-3 fw-bold c-darkOrange">{t("FAQ")}</h1>
            <div className="accordion accordion-flush" id="FAQ">
                {(i18n.language === "ar" ? FAQDataAr : FAQDataEn)[0]?.faqData
                    .map((item, i) => (
                        <FAQAccordionItem
                            key={i}
                            ParentId="FAQ"
                            headingId={`head-${item?.questionId}`}
                            collapseId={`collapse-${item?.questionId}`}
                            title={item?.question}
                            ChildComponent={item?.answer}
                        />
                    )
                    )}
            </div>
            <h3 className="my-3 c-darkBeige-10">{t("FAQ_Print")}</h3>
            <div className="accordion accordion-flush" id="FAQ_Print">
                {(i18n.language === "ar" ? FAQDataAr : FAQDataEn)[1]?.faqData
                    .map((item, i) => (
                        <FAQAccordionItem
                            key={i}
                            ParentId="FAQ_Print"
                            headingId={`headPrint-${item?.questionId}`}
                            collapseId={`collapsePrint-${item?.questionId}`}
                            title={item?.question}
                            ChildComponent={item?.answer}
                        />
                    )
                    )}
            </div>
            <h3 className="my-3 c-darkBeige-10">{t("FAQ_Books")}</h3>
            <div className="accordion accordion-flush" id="FAQ_Books">
                {(i18n.language === "ar" ? FAQDataAr : FAQDataEn)[2]?.faqData
                    .map((item, i) => (
                        <FAQAccordionItem
                            key={i}
                            ParentId="FAQ_Books"
                            headingId={`headBooks-${item?.questionId}`}
                            collapseId={`collapseBooks-${item?.questionId}`}
                            title={item?.question}
                            ChildComponent={item?.answer}
                        />
                    )
                    )}
            </div>
            <h3 className="my-3 c-darkBeige-10">{t("FAQ_Web")}</h3>
            <div className="accordion accordion-flush" id="FAQ_Web">
                {(i18n.language === "ar" ? FAQDataAr : FAQDataEn)[3]?.faqData
                    .map((item, i) => (
                        <FAQAccordionItem
                            key={i}
                            ParentId="FAQ_Web"
                            headingId={`headWeb-${item?.questionId}`}
                            collapseId={`collapseWeb-${item?.questionId}`}
                            title={item?.question}
                            ChildComponent={item?.answer}
                        />
                    )
                    )}
            </div>
            <h3 className="my-3 c-darkBeige-10">{t("FAQ_Systems")}</h3>
            <div className="accordion accordion-flush" id="FAQ_Systems">
                {(i18n.language === "ar" ? FAQDataAr : FAQDataEn)[4]?.faqData
                    .map((item, i) => (
                        <FAQAccordionItem
                            key={i}
                            ParentId="FAQ_Systems"
                            headingId={`headSystems-${item?.questionId}`}
                            collapseId={`collapseSystems-${item?.questionId}`}
                            title={item?.question}
                            ChildComponent={item?.answer}
                        />
                    )
                    )}
            </div>
        </div>
    );
}

